import React, { useState, useEffect } from "react";

// value/onChange use YYYY-MM-DD; displays and accepts DD-MM-YYYY
export default function DateInput({ value, onChange, className }) {
  const toDisplay = (iso) => {
    if (!iso) return "";
    const [y, m, d] = iso.split("-");
    if (y && m && d) return `${d}-${m}-${y}`;
    return iso;
  };
  const [display, setDisplay] = useState(() => toDisplay(value));
  useEffect(() => { setDisplay(toDisplay(value)); }, [value]);

  const handle = (e) => {
    let raw = e.target.value.replace(/[^\d]/g, "").slice(0, 8);
    let formatted = raw;
    if (raw.length > 4) formatted = raw.slice(0, 2) + "-" + raw.slice(2, 4) + "-" + raw.slice(4);
    else if (raw.length > 2) formatted = raw.slice(0, 2) + "-" + raw.slice(2);
    setDisplay(formatted);
    const iso = raw.length === 8 ? `${raw.slice(4)}-${raw.slice(2, 4)}-${raw.slice(0, 2)}` : "";
    onChange({ target: { value: iso } });
  };

  return <input value={display} onChange={handle} placeholder="DD-MM-YYYY" className={className} />;
}
